export default __webpack_public_path__ + "static/media/person_banner_recortado.5de8c87a.png";